<div class="d-flex justify-content-center">
  <div class="h3 mx-2">Historical View</div>
  <div class="h3 mx-2 text-secondary"><i class="fa-solid fa-clock-rotate-left"></i></div>
</div>

<div class="row mb-2">
  <div class="col-12">
    <div class="d-flex flex-row align-items-end">
      <div class="px-2">
        <div>Start Date</div>
        <input [(ngModel)]="startDate" class="form-control" type="date" data-testid="user-page-history-start-date">
      </div>

      <div class="px-2">
        <div>End Date</div>
        <input [(ngModel)]="endDate" class="form-control" type="date" data-testid="user-page-history-end-date">
      </div>

      <div class="px-2 filter-user">
        <div>User</div>
        <select [(ngModel)]="selectedUserId" class="form-control" data-testid="user-page-history-selected-user-id">
          <option [ngValue]="null">All Users</option>
          <option *ngFor="let rep of repRows" [ngValue]="rep.userId">{{rep.repName}}</option>
        </select>
      </div>

      <div class="px-2">
        <button (click)="loadHistory()" class="btn btn-primary" data-testid="user-page-history-load">Load</button>
      </div>

      <div class="px-2">
        <button (click)="clearFilters()" class="btn btn-secondary" data-testid="user-page-history-reset">Reset</button>
      </div>
    </div>
  </div>
</div>

<ngx-datatable class="material striped user-page-list-table" [rows]="historyData"
   [headerHeight]="40" [footerHeight]="40" [rowHeight]="35" [scrollbarV]="true" [columnMode]="columnMode.force"
   [loadingIndicator]="loadingIndicator">
  <ngx-datatable-column [cellClass]="getCellClass" [headerClass]="text-center" *ngFor="let column of tableColumns; let i = index"
  name="{{column.name}}" prop="{{column.prop}}" [width]="column.width">
    <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop == 'initials'">
      <div class=" w-100 d-flex justify-content-center">
        <span  class="badge rounded-pill bg-white user-page-list-border mx-2 my-0 p-0" [ngStyle]="{'border-color': row.backgroundColor}" >
          <span class="badge rounded-pill text-white font-weight-normal m-0 p-2 user-page-list-text user-page-list-border" [ngStyle]="{'background-color': row.backgroundColor}" >
            {{ value}}
          </span>
        </span>
      </div>
    </ng-template>
    <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop == 'timestamp'">
      {{value + 'Z' | date: 'M/d/yy, h:mm:ss a'}}
    </ng-template>
    <ng-template ngx-datatable-cell-template let-value="value" let-row="row" *ngIf="column.prop == 'url'" let-rowIndex="rowIndex">
      <span>{{row.actionPrefix}}</span>
      <span *ngIf="row.linkUrl" class="text-primary" role="button" (click)="redirectTo(row.linkUrl)" [attr.data-testid]="'user-page-history-redirect-to-' + i + '-' + rowIndex">
        <u>{{row.displayText}}</u>
      </span>
      <span *ngIf="!row.linkUrl">{{row.displayText}}</span>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>



// WEBPACK FOOTER //
// ./src/app/core/components/user-tracking/user-page-history/user-page-history.component.html